import React from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { CustomAutocomplete } from "./AutoComplete";

export const CustomersAutoComplete = ({ value, onChange }) => {
  const Customers = useSelector((state) => state.customers.customers);

  return (
    <CustomAutocomplete
    options={Customers}
    getOptionLabel={(option) =>  option.name_english + " " + option.name_urdu}
    value={value}
    onChange={onChange}
    label="Select Customer"
  />
  );
};
